module.exports = __webpack_public_path__ + "static/media/15695224754281257328794.0379b89f.jpg";